import React, { useRef, useState, useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import HomeBanner from "../../components/home-component/home-banner";
import HomeGallery from "../../components/home-component/home-gallery";
import AboutOverview from "../../components/home-component/about-us";
import Amenities from "../../components/home-component/amenities";
import PlotTable from "../../components/plots-data";
import HomeReservation from "../../components/home-component/home-reservation";
import Footer from "../../components/common/footer";
import HeaderTop from "../../components/common/top-header";
import VideoPlayer from "../../components/home-component/VideoPlayer";
import Amenities1 from "../../components/home-component/amenities1";
import SEOManager from "../../SeoManager";
import VillaGallery from "../../components/home-component/villa-gallery";

const Home = () => {
  const [selectedPlot, setSelectedPlot] = useState(null);
  const homeReservationRef = useRef(null);

  const handleSelectPlot = (plot) => {
  setSelectedPlot(plot);

  const element = homeReservationRef.current;
  if (element) {
    const yOffset = window.innerWidth < 768 ? 450 : 0; // scroll 100px further on mobile
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};


const scrollToSection = (id, offset = 100) => {
  const el = document.getElementById(id);
  if (!el) return;

  const y = el.getBoundingClientRect().top + window.pageYOffset + offset;
  console.log({ id, scrollTo: y });
  window.scrollTo({ top: y, behavior: "smooth" });
};

useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);

  return (
    <>
    <SEOManager />
      <HeaderTop />

      <section id="home" data-aos="fade-up">
        <HomeBanner />
      </section>
      <div className="backGround">

      <section id="About-Us" data-aos="fade-right">
        <AboutOverview />
      </section>

    

      <section id="Configuration" data-aos="fade-left">
        <PlotTable onSelectPlot={handleSelectPlot} />
      </section>

      

       <section id="Overview" data-aos="fade-down">
        <Amenities />
        {/* <Amenities1/> */}
      </section>

      <section id="Amenities" data-aos="zoom-in-up">
        <HomeGallery />
      </section>

      <section id="videoplayer"data-aos="zoom-in-down">
        <VideoPlayer />
      </section>

      <section id="villa-gallery" data-aos="fade-up">
        <VillaGallery />
        </section>
     

      <section id="Contact" ref={homeReservationRef}>
        <HomeReservation selectedPlotData={selectedPlot} />
      </section>
       </div>

       <div
  className="position-fixed bottom-0 start-0 w-100 d-flex justify-content-around bg-white py-2 border-top d-block d-md-none"
  style={{ zIndex: 1050 }}
>
  <button
    className="btn btn-success w-50 me-1 text-white"
    style={{ backgroundColor: "rgb(40 167 69)" }}
    onClick={() => scrollToSection("home", 580)}
  >
    Enquiry
  </button>

  <a
    href="tel:+918098725026"
    className="btn btn-success w-50 ms-1 text-white"
    style={{ backgroundColor: "rgb(40 167 69)" }}
  >
    Call 
  </a>
</div>


      <Footer />
    </>
  );
};

export default Home;
